module.exports = __webpack_public_path__ + "img/餐饮-松露奶茶双排.f973f6a4.jpg";